<template>
  <div id="center">
    <!-- <img src="../assets/image/1.png" alt="" /> -->
  </div>
</template>

<script>
export default {
  name: "GiadaCentre",

  data () {
    return {};
  },

  mounted () { },

  methods: {},
};
</script>

<style lang="scss" scoped>
#center {
  width: 100%;
  height: 1400px;
  img {
    width: 100%;
  }
}
</style>